import { selectCartQuantity, selectCheckoutLink } from "@redux/selectors"
import { Dispatch, RootState } from "@redux/store"
import { connect } from "react-redux"
import { CartItem } from "../../../redux/types"
import Cart from "../index"

interface ownProps {
  isOpen: boolean
  onRequestClose: () => void
}

const mapState = (state: RootState, ownProps: ownProps) => {
  return {
    showSignIn: !!state.customer.customerAccessToken,
    items: state.checkout.localCheckout?.items || [],
    subtotal: state.checkout.localCheckout?.subtotal || "",
    total: state.checkout.localCheckout?.total || "",
    cartCount: selectCartQuantity(state),
    checkoutId: state.checkout.checkoutId,
    checkoutLink: selectCheckoutLink(state),
  }
}

const mapDispatch = (dispatch: Dispatch) => ({
  onUpdateCartItem: (cartItem: CartItem) =>
    dispatch.checkout.updateCart(cartItem),
  onRemoveCartItem: (cartItem: CartItem) =>
    dispatch.checkout.removeCartItem(cartItem),
  onUpdateDiscount: dispatch.checkout.updateDiscount,
  onRemoveDiscount: () => {
    dispatch.checkout.updateDiscount(undefined)
  },
})

export default (connect(mapState, mapDispatch) as any)(Cart)
